<app-alert></app-alert>
<div class="wrapper">
    <div *ngIf="companyName; else companyNameLoader" class="pageTitleHeader">
        <div class="pageTitle">
            <h1 class="mat-headline-4 pageTitle__name" data-testid="company-name">{{companyName}}</h1>
            <a mat-icon-button *ngIf="currentUser.role === 'ADMIN'"
                routerLink="/company"
                class="companyEditLink">
                <mat-icon>edit</mat-icon>
            </a>
        </div>

    </div>
    <ng-template #companyNameLoader>
        <div class="skeleton" style="width: auto;">
            <div class="bone" style="height: 40px; width: 18vw; margin-bottom: 54px;"></div>
        </div>
    </ng-template>

    <div *ngIf="ownConnections !== null && testConnections !== null; else loader"
        [ngClass]="{'home': !isDemo, 'demoHome': isDemo}">
        <app-own-connections
            [currentUser]="currentUser"
            [connections]="ownConnections"
            [isDemo]="isDemo">
        </app-own-connections>

        <mat-divider *ngIf="testConnections && testConnections.length"
            class="connections-divider"
            [ngClass]="{'connections-divider_or': isDemo}">
        </mat-divider>

        <app-demo-connections *ngIf="testConnections && testConnections.length"
            [testConnections]="testConnections"
            [isDemo]="isDemo">
        </app-demo-connections>
    </div>
    <ng-template #loader>
        <app-placeholder-connections class="placeholder"></app-placeholder-connections>
    </ng-template>
</div>
